import React, { Fragment, useCallback, useMemo, useState } from 'react'
import { MultiSelect } from 'carbon-components-react'
import { isEmpty, size } from 'lodash'

import './index.scss'

const MultiSelectWithSelectAll = (props) => {
  const { id, initialSelectedItems, items, onChange, selectOptions } = props
  const { titleText, btnLabels, ...otherProps } = props

  const { select: SELECT_LABEL, deselect: DESELECT_LABEL } = btnLabels

  const [selectedItems, setSelectedItems] = useState(initialSelectedItems)

  const selectAllBtn = useMemo(() => {
    if (isEmpty(items)) return ''

    return size(selectedItems) === size(items) ? DESELECT_LABEL : SELECT_LABEL
  }, [items, selectedItems])

  const handleOnChange = useCallback(
    (e) => {
      const { selectedItems } = e

      if (selectOptions) {
        setSelectedItems(selectedItems)
      }
      onChange(e)
    },
    [onChange]
  )

  const handleSelectedItems = useCallback(() => {
    setSelectedItems((prevItems) => {
      const newItems = size(prevItems) === size(items) ? [] : items

      onChange({
        selectedItems: newItems
      })

      return newItems
    })
  }, [items])

  return (
    <Fragment>
      {selectOptions && (
        <div className='select-options'>
          <span className='bx--label'>{titleText}</span>
          <span className='selectLabel' onClick={handleSelectedItems}>
            {selectAllBtn}
          </span>
        </div>
      )}
      <MultiSelect
        {...otherProps}
        key={`${id}-${selectAllBtn}`}
        onChange={handleOnChange}
        initialSelectedItems={selectedItems}
      />
    </Fragment>
  )
}

MultiSelectWithSelectAll.defaultProps = {
  btnLabels: {
    select: 'SELECT_ALL',
    deselect: 'DESELECT_ALL'
  }
}

export default MultiSelectWithSelectAll
